export const breakpoints = {
  mobileMax: 1023,
  desktopMin: 1024,
  desktopMax: 1921
};
export default breakpoints;